export const addAuthorizationHeaderWithBearer = (headers: Headers) => {
  const token = localStorage.getItem('ncap-token');
  if (token) {
    headers.set('authorization', `Bearer ${token}`);
  }
  return headers;
};
